import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import {BlobServiceClient,AnonymousCredential,newPipeline } from '@azure/storage-blob';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoadFileModel } from '../models/LoadFile.Model';
import Swal from 'sweetalert2'
import { NgxSpinnerService } from 'ngx-spinner';


declare const AzureStorage: any;
declare const fileService: any;

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
});

@Component({
  selector: 'attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss']
})
export class AttachmentComponent implements OnInit {

  //En este input se debe ingresar el nombre del BlobContainer que se va a afectar
  //En caso de no existir se crea el contenedor.
  //@Input('sfcontrol') _sfcontrol: SpecialFormControl;
  @Output('blurAction') _blurAction: EventEmitter<any> = new EventEmitter();
  @Output('enterKey') _enterKey: EventEmitter<any> = new EventEmitter();
  @Input('preRowKey') preRowKey: string;
  @Input() container: string;
  @Input() uploadbool: boolean;
  @Input() admitedTypes: string;

  //form: SpecialFormGroup;
  formFields = [];
  blobService;
  blobArray = [];
  files: File[] = [];
  tokenSAS: string;
  upload: boolean = false;
  admitedTypesArray : any = [];
  compareType: string;
  insertedItems: string;
  event: any;
  uploadButton: boolean = false;

  fileData: File = null;
  previewUrl: any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  constructor(
    private http: HttpClient,
    //public dialog: MatDialog,
    private _router: Router,private SpinnerService: NgxSpinnerService
  ) { }

  ngOnInit() {

    if (!this.uploadbool) {
      this.list()
    }
    //this.list()

    this.admitedTypesArray = this.admitedTypes != undefined ? this.admitedTypes.split(";") : []

  }

  /* 
  ** Metodo Importante!!
  ** Se debe cambiar el token SAS y el nombre de la cuenta de almacenamiento
   */
  getBlobService() {

    const account = {
      sas: environment.tokenSAS,
      name: environment.storageAccountName,
    };

    this.tokenSAS = account.sas;

    const blobUri = 'https://' + account.name + '.blob.core.windows.net';
    const blobService = new  BlobServiceClient(`https://${account.name}.blob.core.windows.net?${account.sas}`);
    this.blobService = blobService;
  }

  /* 
  **
  **
   */
  async createContainer() {

    this.getBlobService()

    // Create a container
    const containerName = `newcontainer${new Date().getTime()}`;
    const containerClient = this.blobService.getContainerClient(containerName);
    const createContainerResponse = await containerClient.create();
    console.log(`Create container ${containerName} successfully`, createContainerResponse.requestId);
  }

  fileProgress(event: any) {
    //alert(event.addedFiles)
    //this.fileData = <File>fileInput.target.files[0];
    this.files.unshift(...event.addedFiles);
    //this.preview();
  }

  /* ------------------------------------------------------ */

  async onPreview(event) {

    let i = 1;
    this.blobArray = [];
    this.event = event
    let blobs = event.addedFiles;
    this.event.addedFiles = [];
    console.log(event)

    if(this.container == "usecases")
    {
      this.compareType = ".zip"
    }
    else
    {
      this.compareType = ".pdf"
    }


    for await (const blob of blobs) {

      console.log(`Blob ${i++}: ${blob.name}`);

      if (blob.name.includes(this.compareType))
      {
        this.blobArray.push({ "blob": blob, "downloadLink": blob.name })

        this.event.addedFiles.push(blob)
        this.uploadButton = true

      }
      else
      {
        Swal.fire({
          title: 'Error!',
          html: `Solo se permite formato ${this.compareType}, para el contenedor ${this.container} <br> Only ${this.compareType} format is allowed, for the container ${this.container}`,
          icon: 'error',
          confirmButtonText: 'Cerrar/Close'
        })
        this.Clean()
      }
    
    }

  }

  async onSubmitPreview(event) 
  {
    this.insertedItems =  ""

    event.addedFiles.forEach(async element => {

      this.insertedItems +=  element.name + "<br>"

      var containerId
      
      switch (this.container) {
        case 'verbs':
          containerId = "1";
          break;
        case 'usecases':
          containerId = "3";
          break;

        case 'releasenotes':
          containerId = "2";
          break;
          
        default:
          break;
      }


        var strarchivo = await this.getBase64(element).then(x => x);

        let rootObject = new LoadFileModel();
        rootObject.categoriaArchivo = containerId;
        rootObject.idUsuario = 23;
        rootObject.archivoB64 = strarchivo;
        rootObject.nombreArchivo = element.name;
         await this.serv_LoadFiles(rootObject);

    });

 
    this.blobArray = [];
    this.uploadButton = false

  }

  public Clean()
  {
    this.blobArray = [];
    this.uploadButton = false
  }

  /* ------------------------------------------------------ */

  async onSubmit(event) {

    this.fileProgress(event)
    this.getBlobService()
  
    if (event.addedFiles.length === 0)
    return;

    var containerId
    switch (this.container) {
      case 'verbs':
        containerId = "1";
        break;
      case 'usecases':
        containerId = "3";
        break;

      case 'releasenotes':
        containerId = "2";
        break;
        
      default:
        break;
    }

    
    this.insertedItems = ""

    console.log(event.addedFiles[0])


    var execute = false

    event.addedFiles.forEach(async element => {

      execute = false
      const foundAll = this.admitedTypesArray.find(element => element == 'all');

      switch (element.type) {
        case 'application/pdf':
          this.compareType = '.pdf';
          break;
        case 'application/x-zip-compressed':
          this.compareType = '.zip';
          break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          this.compareType = '.xlsx';
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          this.compareType = '.docx';
          break;  
        case 'application/x-msdownload':
          this.compareType = '.exe';
          break; 
        default:
          this.compareType = ''
          break;
      }

      if(foundAll != undefined)
      {
        execute = true
      }
      else
      {
        const foundType = this.admitedTypesArray.find(element => element == this.compareType);

        if(foundType != undefined)
        {
          execute = true
        }

      }

      if (execute) {

        this.insertedItems +=  element.name + "<br>"


        var strarchivo = await this.getBase64(element).then(x => x);

        let rootObject = new LoadFileModel();
        rootObject.categoriaArchivo = containerId;
        rootObject.idUsuario = 23;
        rootObject.archivoB64 = strarchivo;
        rootObject.nombreArchivo = element.name;
        await this.serv_LoadFiles(rootObject);

        //this.list()

      } else {
        Swal.fire({
          title: 'Error!',
          html: `Formato no admitido ${this.compareType}, para el contenedor ${this.container} <br> unsupported format ${this.compareType}, for the container ${this.container}`,
          icon: 'error',
          confirmButtonText: 'Cerrar/Close'
        })
      }
     
      
    });


    if (execute) 
    {
      Swal.fire({
        icon: 'success',
        html: `Archivo(s) guardado(s) correctamente en ${this.container} <br> File(s) saved correctly in ${this.container}` + "<br><br>" + this.insertedItems,
        confirmButtonText: 'Cerrar/Close'
      })
    }
    
    /* event.addedFiles.forEach(async element => {

      const containerClient = this.blobService.getContainerClient(this.container)

      const client = containerClient.getBlockBlobClient(element.name)
           
        
      const response = await client.uploadBrowserData(element,{
        blockSize: 4 * 1024 * 1024, // 4MB block size
        concurrency: 20, // 20 concurrency
        onProgress: (ev) => console.log(ev),
        blobHTTPHeaders :{blobContentType:element.type}
        })
     
      
    }); */

    //this.list()
  
  
  
    /* setTimeout(() => {
      //this.list()
    }, 2000); */
      
  }


  /* ------------------------------------------------------ */


  /* 
  **
  **
   */
  async list() {
    this.blobArray = [];
    this.getBlobService()
    //alert(this.container)
    //this.createContainer()

    const containerClient = this.blobService.getContainerClient(this.container);

    let i = 1;
    this.blobArray = [];
    let blobs = containerClient.listBlobsFlat();
    for await (const blob of blobs) {
      console.log(`Blob ${i++}: ${blob.name}`);

      this.blobArray.push({ "blob": blob, "downloadLink": blob.name + this.tokenSAS })
    }
    
  }


  /* 
  **
  **
   */
  async Download(blobName) {
    
    console.log(blobName)
     this.getBlobService()

      const containerClient = this.blobService.getContainerClient(this.container);
      const blobClient = containerClient.getBlobClient(blobName);

      // Get blob content from position 0 to the end
      // In browsers, get downloaded data by accessing downloadBlockBlobResponse.blobBody
      const downloadBlockBlobResponse = await blobClient.download();
      /* const downloaded = await blobToString(await downloadBlockBlobResponse.blobBody); */
      console.log("Downloaded blob content", blobClient);

      window.open(blobClient.url, '_blank')

  }


  async delete(blobName) {

    this.getBlobService()

      const containerClient = this.blobService.getContainerClient(this.container)

      const client = containerClient.getBlockBlobClient(blobName)

      const response = await client.delete()

    //this.list()
  }

  preview() {
    // Show preview 
    var mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = (_event) => {
      this.previewUrl = reader.result;
    }
  }

  private getRequestUrl(controller, action) {
    return `${window.location.origin}/api/${controller}/${action}`;
  }

  async serv_LoadFiles(item: LoadFileModel) {
    const url = this.getRequestUrl("CargaArchivo", "UploadFile");
    this.SpinnerService.show()
    const body = { ObjectRequest: JSON.stringify(item) };
    let response = await this.http.post<object>(url, body)
      .toPromise()
      .catch(ex => {
        var error = ex.error.serverError ? ex.error.serverError : 'error';
        alert("Ocurrio un error" + error);
        return null;
      });
      this.SpinnerService.hide()
      if(response){
        Swal.fire({
          icon: 'success',
          html: `Archivo(s) guardado(s) correctamente en ${this.container} <br> File(s) saved correctly in ${this.container}` + "<br><br>" + this.insertedItems,
          confirmButtonText: 'Cerrar/Close'
    })
      }else{
        Toast.fire("No se pudo cargar el archivo !"," ","error");
      }
        


  }

  async getBase64(file) {
    try {
      return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.toString());
        reader.onerror = error => reject(error);
      });
    } catch (error) {
      console.log(error);
    }
  }

}
